import './PieChart.scss';
import Component from './PieChart';
export default Component;